module.exports = __webpack_public_path__ + "img/mode_5.3f464ae8.png";